var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app",attrs:{"id":"app"}},[_c('global-nav'),_c('global-nav-pc'),_c('div',{staticClass:"view"},[_c('router-view')],1),_c('footer-bar',{class:this.$route.path !== '/contact' ? 'mt-5 pt-5' : 'd-none'})],1)}
var staticRenderFns = []

export { render, staticRenderFns }